import React from "react";
import './ForEmployers.scss';
import forImg from '../../assets/img/forImg.webp';
import Button from "../button/Button";
import { useInView } from 'react-intersection-observer';




function ForEmployers({t,handlerSelectModal}) {
    const{ ref,inView } = useInView({
        threshold:0,
      })
    return (
        <div  ref={ref} className={`for-main animation ${inView ? 'show-for': ""}`}>
            <div className="for-wrapper">
                <div className="for-capture-wrapper">
                    <div className="for-capture">
                        {t("for_employers_capture")}
                    </div>
                    <div className="for-tagline">
                    {t("for_employers_tagline")}
                    </div>
                </div>
                <div className="for-content">
                    <div className="for-img">
                        <img src={forImg} alt="for employers"/>
                    </div>
                    <div className="for-text">
                        <p>
                        {t("for_employers_text1")}
                        </p>
                        <p>
                        {t("for_employers_text2")}
                        </p>
                        <Button text = {t("button_start_your_journey")} handlerSelectModal={handlerSelectModal}/>
                    </div>
                </div>
            </div>
        </div>      
    );
  }
  
  export default ForEmployers;